export interface ChangePasswordFormData {
  new_password: string
  confirm_new_password: string
}

export enum PasswordValidationRule {
  MIN_LENGTH = 'MIN_LENGTH',
  REQUIRE_UPPERCASE = 'REQUIRE_UPPERCASE',
  REQUIRE_LOWERCASE = 'REQUIRE_LOWERCASE',
  REQUIRE_NUMBERS = 'REQUIRE_NUMBERS',
  REQUIRE_SPECIAL_CHARS = 'REQUIRE_SPECIAL_CHARS'
}

export type PasswordValidationConfig = {
  [PasswordValidationRule.MIN_LENGTH]: number
  [PasswordValidationRule.REQUIRE_UPPERCASE]?: boolean
  [PasswordValidationRule.REQUIRE_LOWERCASE]?: boolean
  [PasswordValidationRule.REQUIRE_NUMBERS]?: boolean
  [PasswordValidationRule.REQUIRE_SPECIAL_CHARS]?: boolean
}

export interface ChangePasswordInputsProps {
  onSubmit: (formData: ChangePasswordFormData) => Promise<void> | void
  validationConfig: PasswordValidationConfig
  loading?: boolean
  submitButtonText?: string
  disabled?: boolean
}

export interface PasswordValidationResult {
  isValid: boolean
  message?: string
}

export interface PasswordRuleResult {
  rule: PasswordValidationRule
  label: string
  isValid: boolean
  isRequired: boolean
}
